// src/components/admin/Settings.js
import React from 'react';
import { Box, Typography } from '@mui/material';

const Settings = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Paramètres
      </Typography>
      <Typography variant="body1">
        Cette page vous permet de modifier les paramètres de l'application.
      </Typography>
    </Box>
  );
};

export default Settings;
